import React from 'react';
import groupOfRebateProgHead from './gridComponents/tableHead';
import TableGridWithFeatures from '../Table/TableGridWithFeatures';
import { tableGridHight350 } from '../CommonConstants/commonConstants';

const GroupOfRebateProgramComponent = (props) => {
  const { fullScreenView, data, fileName, handleFullScreenView } = props;
  return (
    <>
      <TableGridWithFeatures
        data-testid="manufacturer-cbi-table"
        rowSelection="single"
        rowMultiSelectWithClick={false}
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={() => handleFullScreenView(!fullScreenView)}
        gridHeight={fullScreenView ? '70vh' : tableGridHight350}
        rowData={data}
        columnDefs={groupOfRebateProgHead}
        exportFile
        fileName={fileName}
        helpMessage=""
        animateRows
        sideBar={false}
        singleClickEdit={false}
        enterMovesDown
        suppressCellFocus
      />
    </>
  );
};
export default GroupOfRebateProgramComponent;
